import type { ApiResource } from '../types';
import type { AiTransacrionAnalysisResponse, AiTransacrionsAnalysesResponse } from 'types/api/ai';

export const AI_API_RESOURCES = {
  transactions_analyses: {
    path: '/api/v1/transactions/analyses',
  },
  transaction_analysis: {
    path: '/api/v1/transactions/:tx_hash/analysis',
    pathParams: [ 'tx_hash' ],
  },
} satisfies Record<string, ApiResource>;

export type AiApiResourceName = `ai:${ keyof typeof AI_API_RESOURCES }`;

/* eslint-disable @stylistic/indent */
export type AiApiResourcePayload<R extends AiApiResourceName> =
R extends 'ai:transactions_analyses' ? AiTransacrionsAnalysesResponse :
R extends 'ai:transaction_analysis' ? AiTransacrionAnalysisResponse :
never;
/* eslint-enable @stylistic/indent */
